import { fetchAuthToken } from '../api/notifications'
import {
  getWebPushPublicKey,
  getWebPushSubscriptions,
  subscribeWebPush,
  unsubscribeWebPush,
} from '../api_client_portal/webPush'
import type { Resolvers } from '../generated/server/resolvers'

const NotificationsResolver: Resolvers = {
  Query: {
    getNotificationsToken: async () => await fetchAuthToken(),
    getWebPushPublicKey: async () => await getWebPushPublicKey(),
    getWebPushSubscriptions: async () => await getWebPushSubscriptions(),
  },
  Mutation: {
    subscribeWebPush: async (_parent, { input }) => await subscribeWebPush(input),
    unsubscribeWebPush: async (_parent, { id }) => await unsubscribeWebPush(id),
  },
}

export default NotificationsResolver
